import React from 'react';
import { Box, Typography, IconButton, Grid, useMediaQuery, useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, isSameMonth, isSameDay, startOfWeek, endOfWeek } from 'date-fns';

const CalendarMain = ({
  selectedDate,
  setSelectedDate,
  handleDateChange,
  isMobile,
  globalAvailability
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const renderCalendarDays = () => {
    const monthStart = startOfMonth(selectedDate);
    const monthEnd = endOfMonth(selectedDate);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);

    const dateRange = eachDayOfInterval({ start: startDate, end: endDate });

    return dateRange.map((date) => {
      const isCurrentMonth = isSameMonth(date, selectedDate);
      const isToday = isSameDay(date, new Date());
      const isSelected = isSameDay(date, selectedDate);
      const dayName = format(date, 'EEEE').toLowerCase();
      const isAvailable = globalAvailability[dayName].available;

      return (
        <Grid item xs={1.7} key={date.toISOString()}>
          <Box
            sx={{
              height: '100%',
              border: '1px solid #e0e0e0',
              opacity: isCurrentMonth ? 1 : 0.3,
              bgcolor: isToday ? 'rgba(0, 255, 0, 0.1)' : isSelected ? 'rgba(0, 0, 255, 0.1)' : isAvailable ? 'transparent' : 'rgba(255, 0, 0, 0.1)',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: isSmallScreen ? '40px' : '80px',
            }}
            onClick={() => setSelectedDate(date)}
          >
            <Typography
              variant={isSmallScreen ? "caption" : "body2"}
              sx={{
                fontWeight: isToday ? 'bold' : 'normal',
              }}
            >
              {format(date, 'd')}
            </Typography>
          </Box>
        </Grid>
      );
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden', p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <IconButton size="small" onClick={() => handleDateChange(-1)}><ChevronLeftIcon /></IconButton>
        <Typography variant={isSmallScreen ? "subtitle1" : "h6"}>{format(selectedDate, 'MMMM yyyy')}</Typography>
        <IconButton size="small" onClick={() => handleDateChange(1)}><ChevronRightIcon /></IconButton>
      </Box>
      <Grid container spacing={0} sx={{ flexGrow: 1 }}>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
          <Grid item xs={1.7} key={`day-${index}`}>
            <Typography variant="caption" align="center" sx={{ fontWeight: 'bold', display: 'block', mb: 1 }}>
              {day}
            </Typography>
          </Grid>
        ))}
        {renderCalendarDays()}
      </Grid>
    </Box>
  );
};

export default CalendarMain;
